<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Customer Alert</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p class="text-secondary">
      Alerts are shown in the Staff Site Customer Profile, as well as in the Check In Site when a customer checks in. An alert will be visible until it expires or is dismissed.
    </p>

    <div class="form-group">
      <label for="alertTextInput">Alert Text *</label>
      <input type="text" class="form-control" id="alertTextInput" name="alertText"
             required
             [(ngModel)]="customerAlert.alert_text">
      <div class="form-text text-danger">{{ errors.alert_text }}</div>
    </div>

    <div class="form-group">
      <label for="expiryDateInput">Expiration Date (Optional)</label>
      <app-date-picker [id]="'expiryDateInput'"
                       [(content)]="customerAlert.expiry_date"></app-date-picker>
      <div class="form-text text-danger">{{ errors.expiry_date }}</div>
    </div>

    <div class="form-group">
      <label for="colorHexSelect">Color *</label>
      <app-color-picker [id]="'colorHexSelect'"
                        [(content)]="customerAlert.color_hex"
                        [cpPosition]="'top-right'"></app-color-picker>
      <div class="form-text text-danger">{{ errors.color_hex }}</div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="prevents_check_in" name="prevents_check_in"
               [(ngModel)]="customerAlert.prevents_check_in">
        <label class="form-check-label" for="prevents_check_in">
          Prevent the customer from checking in while this alert is active
        </label>
      </div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="has_alert_icon" name="has_alert_icon"
               [(ngModel)]="customerAlert.has_alert_icon">
        <label class="form-check-label" for="has_alert_icon">
          Add an alert icon to the customer while this alert is active
        </label>
      </div>
      <small class="form-text text-muted">
        The alert icon (a triangle with an exclamation point) will appear next to the customer's name on the Check-In Site and event participant list.
      </small>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
